import { Countries } from '../../data/Countries';
import { Timezones } from '../../data/Timezones';

const getCountryCode = (userTz: string) => {
  //Set initial phone code - Timezone hack :)
  let uci = 0;
  if (userTz && userTz !== '' && userTz in Timezones) {
    const userTzCountries = Timezones[userTz].c;
    if (userTzCountries) {
      uci = Countries.findIndex((c) => c.code == userTzCountries[0]); //find by code
    } else {
      uci = Countries.findIndex((c) => c.code == userTz.split('/')[0]); //find if code in name
    }
    if (uci < 0) uci = 0;
  }
  return uci;
};

export default getCountryCode;
